export default "__VITE_ASSET__BrgbF_Je__"